<template>
  <div class="bgd-wrp">
    <div class="con">
      <h1>Select a cuisine</h1>
      <div class="inputItem">
        <input type="text" placeholder="Start typing to search…" v-model="key" @input="filter" />
      </div>
      <ul class="clear">
        <li :style="{'cursor': ten === true ? item.isChecked === false ? 'no-allowed' : 'pointer' : 'pointer'}" v-for="item in lst" :key="item.name" @click="choose(item.name)" :class="{'red': item.isChecked,'hidden': item.hidden === true}">{{item.name}}</li>
      </ul>
      <div class="btns clear">
        <button class="dark" @click="cancel">Cancel</button>
        <button class="light" @click="add">Add</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      lst: [
        {
          name: 'Afghan',
          isChecked: false
        },
        {
          name: 'African',
          isChecked: false
        },
        {
          name: 'American',
          isChecked: false
        },
        {
          name: 'Arabian',
          isChecked: false
        },
        {
          name: 'Argentine',
          isChecked: false
        },
        {
          name: 'Asian',
          isChecked: false
        },
        {
          name: 'Asian Fusion',
          isChecked: false
        },
        {
          name: 'Australian',
          isChecked: false
        },
        {
          name: 'Austrian',
          isChecked: false
        },
        {
          name: 'BBQ',
          isChecked: false
        },
        {
          name: 'Bakery',
          isChecked: false
        },
        {
          name: 'Bangladeshi',
          isChecked: false
        },
        {
          name: 'Bar Food',
          isChecked: false
        },
        {
          name: 'Basque',
          isChecked: false
        },
        {
          name: 'Belgian',
          isChecked: false
        },
        {
          name: 'Beverages',
          isChecked: false
        },
        {
          name: 'Brazilian',
          isChecked: false
        },
        {
          name: 'British',
          isChecked: false
        },
        {
          name: 'Bubble Tea',
          isChecked: false
        },
        {
          name: 'Burger',
          isChecked: false
        },
        {
          name: 'Burmese',
          isChecked: false
        },
        {
          name: 'Cabinet Food',
          isChecked: false
        },
        {
          name: 'Cafe Food',
          isChecked: false
        },
        {
          name: 'Cambodian',
          isChecked: false
        },
        {
          name: 'Cantonese',
          isChecked: false
        },
        {
          name: 'Caribbean',
          isChecked: false
        },
        {
          name: 'Charcoal Chicken',
          isChecked: false
        },
        {
          name: 'Chinese',
          isChecked: false
        },
        {
          name: 'Coffee and Tea',
          isChecked: false
        },
        {
          name: 'Colombian',
          isChecked: false
        },
        {
          name: 'Contemporary',
          isChecked: false
        },
        {
          name: 'Continental',
          isChecked: false
        },
        {
          name: 'Creole',
          isChecked: false
        },
        {
          name: 'Crepes',
          isChecked: false
        },
        {
          name: 'Croatian',
          isChecked: false
        },
        {
          name: 'Danish',
          isChecked: false
        },
        {
          name: 'Deli',
          isChecked: false
        },
        {
          name: 'Desserts',
          isChecked: false
        },
        {
          name: 'Drinks Only',
          isChecked: false
        },
        {
          name: 'Dumplings',
          isChecked: false
        },
        {
          name: 'Dutch',
          isChecked: false
        },
        {
          name: 'Eastern European',
          isChecked: false
        },
        {
          name: 'Egyptian',
          isChecked: false
        },
        {
          name: 'Ethiopian',
          isChecked: false
        },
        {
          name: 'European',
          isChecked: false
        },
        {
          name: 'Falafel',
          isChecked: false
        },
        {
          name: 'Filipino',
          isChecked: false
        },
        {
          name: 'Finger Food',
          isChecked: false
        },
        {
          name: 'Fish and Chips',
          isChecked: false
        },
        {
          name: 'French',
          isChecked: false
        },
        {
          name: 'Fried Chicken',
          isChecked: false
        },
        {
          name: 'Frozen Yogurt',
          isChecked: false
        },
        {
          name: 'Fusion',
          isChecked: false
        },
        {
          name: 'Georgian',
          isChecked: false
        },
        {
          name: 'German',
          isChecked: false
        },
        {
          name: 'Greek',
          isChecked: false
        },
        {
          name: 'Grill',
          isChecked: false
        },
        {
          name: 'Hawaiian',
          isChecked: false
        },
        {
          name: 'Healthy Food',
          isChecked: false
        },
        {
          name: 'Hot Pot',
          isChecked: false
        },
        {
          name: 'Hungarian',
          isChecked: false
        },
        {
          name: 'Ice Cream',
          isChecked: false
        },
        {
          name: 'Indian',
          isChecked: false
        },
        {
          name: 'Indonesian',
          isChecked: false
        },
        {
          name: 'International',
          isChecked: false
        },
        {
          name: 'Iranian',
          isChecked: false
        },
        {
          name: 'Iraqi',
          isChecked: false
        },
        {
          name: 'Irish',
          isChecked: false
        },
        {
          name: 'Israeli',
          isChecked: false
        },
        {
          name: 'Italian',
          isChecked: false
        },
        {
          name: 'Japanese',
          isChecked: false
        },
        {
          name: 'Japanese BBQ',
          isChecked: false
        },
        {
          name: 'Jewish',
          isChecked: false
        },
        {
          name: 'Juices',
          isChecked: false
        },
        {
          name: 'Kebab',
          isChecked: false
        },
        {
          name: 'Korean',
          isChecked: false
        },
        {
          name: 'Korean BBQ',
          isChecked: false
        },
        {
          name: 'Latin American',
          isChecked: false
        },
        {
          name: 'Lebanese',
          isChecked: false
        },
        {
          name: 'Malatang',
          isChecked: false
        },
        {
          name: 'Malaysian',
          isChecked: false
        },
        {
          name: 'Mauritian',
          isChecked: false
        },
        {
          name: 'Meat Pie',
          isChecked: false
        },
        {
          name: 'Mediterranean',
          isChecked: false
        },
        {
          name: 'Mexican',
          isChecked: false
        },
        {
          name: 'Middle Eastern',
          isChecked: false
        },
        {
          name: 'Modern Australian',
          isChecked: false
        },
        {
          name: 'Modern European',
          isChecked: false
        },
        {
          name: 'Mongolian',
          isChecked: false
        },
        {
          name: 'Moroccan',
          isChecked: false
        },
        {
          name: 'Nepalese',
          isChecked: false
        },
        {
          name: 'North Indian',
          isChecked: false
        },
        {
          name: 'Pacific',
          isChecked: false
        },
        {
          name: 'Pakistani',
          isChecked: false
        },
        {
          name: 'Pan Asian',
          isChecked: false
        },
        {
          name: 'Parma',
          isChecked: false
        },
        {
          name: 'Pastry',
          isChecked: false
        },
        {
          name: 'Patisserie',
          isChecked: false
        },
        {
          name: 'Peruvian',
          isChecked: false
        },
        {
          name: 'Pho',
          isChecked: false
        },
        {
          name: 'Pizza',
          isChecked: false
        },
        {
          name: 'Poké',
          isChecked: false
        },
        {
          name: 'Polish',
          isChecked: false
        },
        {
          name: 'Portuguese',
          isChecked: false
        },
        {
          name: 'Pub Food',
          isChecked: false
        },
        {
          name: 'Ramen',
          isChecked: false
        },
        {
          name: 'Roast',
          isChecked: false
        },
        {
          name: 'Russian',
          isChecked: false
        },
        {
          name: 'Salad',
          isChecked: false
        },
        {
          name: 'Sandwich',
          isChecked: false
        },
        {
          name: 'Satay',
          isChecked: false
        },
        {
          name: 'Scandinavian',
          isChecked: false
        },
        {
          name: 'Scottish',
          isChecked: false
        },
        {
          name: 'Seafood',
          isChecked: false
        },
        {
          name: 'Shanghai',
          isChecked: false
        },
        {
          name: 'Sichuan',
          isChecked: false
        },
        {
          name: 'Singaporean',
          isChecked: false
        },
        {
          name: 'Soul Food',
          isChecked: false
        },
        {
          name: 'South African',
          isChecked: false
        },
        {
          name: 'South Indian',
          isChecked: false
        },
        {
          name: 'Spanish',
          isChecked: false
        },
        {
          name: 'Sri Lankan',
          isChecked: false
        },
        {
          name: 'Steak',
          isChecked: false
        },
        {
          name: 'Street Food',
          isChecked: false
        },
        {
          name: 'Sushi',
          isChecked: false
        },
        {
          name: 'Swedish',
          isChecked: false
        },
        {
          name: 'Swiss',
          isChecked: false
        },
        {
          name: 'Syrian',
          isChecked: false
        },
        {
          name: 'Taiwanese',
          isChecked: false
        },
        {
          name: 'Tapas',
          isChecked: false
        },
        {
          name: 'Tea',
          isChecked: false
        },
        {
          name: 'Teppanyaki',
          isChecked: false
        },
        {
          name: 'Teriyaki',
          isChecked: false
        },
        {
          name: 'Tex-Mex',
          isChecked: false
        },
        {
          name: 'Thai',
          isChecked: false
        },
        {
          name: 'Tibetan',
          isChecked: false
        },
        {
          name: 'Turkish',
          isChecked: false
        },
        {
          name: 'Ukrainian',
          isChecked: false
        },
        {
          name: 'Uruguayan',
          isChecked: false
        },
        {
          name: 'Uyghur',
          isChecked: false
        },
        {
          name: 'Vegan',
          isChecked: false
        },
        {
          name: 'Vegetarian',
          isChecked: false
        },
        {
          name: 'Venezuelan',
          isChecked: false
        },
        {
          name: 'Vietnamese',
          isChecked: false
        },
        {
          name: 'Yum Cha',
          isChecked: false
        }
      ],
      result: '',
      key: '',
      ten: false
    }
  },
  props: {
    checked: {
      type: String,
      default: ''
    }
  },
  created () {
    var that = this
    if (that.checked !== '') {
      const checked = that.checked.split(',')
      checked.forEach(c => {
        this.lst.forEach(v => {
          if (v.name == c) {
            v.isChecked = true
          }
        })
      })
    }
  },
  methods: {
    filter () {
      if (this.key.replace(/\s+/g,'') === '') {
        this.lst.forEach(item => {
          item.hidden = false
        })
        return
      }
      this.lst.forEach(item => {
        if (item.name.toLowerCase().indexOf(this.key) === -1) {
          item.hidden = true
        } else {
          item.hidden = false
        }
      })
    },
    choose (item) {
      let result = []
      this.lst.forEach(v => {
        if (v.isChecked == true) {
            result.push(v.name)
        }
      })
      this.lst.find(v => {
        if (v.name == item && !v.isChecked) {
          if (result.length > 9) {
            Utils.alert('', 'A maximum of 10 can be added', 'error')
            this.ten = true
            return
          }
          v.isChecked = true
        } else if (v.name == item && v.isChecked) {
          v.isChecked = false
          this.ten = false
        }
      })
    },
    cancel () {
      this.$emit('eventCacncel')
    },
    add () {
      var that = this
      this.lst.forEach(v => {
        if (v.isChecked == true) {
          if (that.result == '')
            that.result = v.name
          else
            that.result = that.result + ',' + v.name
        }
      })
      this.$emit('eventConfirm', that.result)
    }
  }
}
</script>

<style lang="scss" scoped>
.bgd-wrp{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  background:rgba(33,36,41,0.6);
  z-index: 10;
  .con{
    width: 840px;
    height: 812px;
    position: fixed;
    left: 50%;
    top: 50%;
    margin: -406px 0 0 -420px;
    background: #2B3444;
    box-sizing: border-box;
    padding: 50px 50px 0 50px;
    h1{
      font-size: 30px;
      line-height: 42px;
      margin-bottom: 50px;
      font-family: 'PingFangSC-Semibold';
      color: #fff;
    }
    .inputItem{
      width: 100%;
      margin-bottom: 40px;
      input{
        outline: none;
        width: 100%;
        height: 50px;
        background:rgba(21,28,39,1);
        border:1px solid rgba(95,95,95,1);
        font-size: 18px;
        color: #fff;
        box-sizing: border-box;
        padding: 0 20px;
        font-family: 'PingFangSC-Regular';
      }
      input::-webkit-input-placeholder{
        color: #8A8D93;
      }
    }
    ul{
      width: 100%;
      max-height: 390px;
      margin-bottom: 65px;
      overflow-y: auto;
      li{
        width: 33.33%;
        float: left;
        box-sizing: border-box;
        margin-bottom: 20px;
        font-size: 18px;
        line-height: 21px;
        cursor: pointer;
      }
      li:nth-child(n), li:nth-child(2n){
        padding-right: 20px;
      }
      .red{
        color: #D13A90;
      }
      .hidden{
        display: none;
      }
    }
    .btns{
      width: 610px;
      margin: 0 auto;
      button{
        outline: none;
        width:280px;
        height:60px;
        font-size:26px;
        font-family: 'PingFangSC-Semibold';
        display: block;
        background-color: transparent;
        cursor: pointer;
      }
      .dark{
        border:2px solid rgba(255,255,255,1);
        color: #fff;
        float: left;
      }
      .light{
        border:2px solid rgba(209,58,144,1);
        color: #D13A90;
        float: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/cuisine.vue